import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StatusTagContainer = styled('div')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.space._100,
    padding: theme.space._10
}));

export const StatusTagTypography = styled(Typography)(({ theme }) => ({
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights.base,
    color: theme.colors["neutral.50"]
}));

